import { of } from 'rxjs';
import { combineEpics, ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { loadFlightControl } from '../FlightDetails/FlightDetails.ducks';
import { loadOverview } from '../../ducks/FlightOverview.ducks';
import { updatingFlight, updatedFlight, loadingManagementGroupPaths, loadedManagementGroupPaths, loadPathsActionTypes, navigateToDetails, updateFlightActionTypes, navigatedToDetails, } from './FlightEdit.ducks';
import * as ReduxObservablesEpicUtils from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { getTenantFromManagementGroup } from '@ane/exp-data/lib/utils/ManagementGroup';
import FlightResource from '../../resources/Flight.resource';
import { getCompletedAsyncWrapperObj, AsyncRequestStatus } from '@ane/core/lib/models/IAsyncWrapper';
import MdsDataplaneResource from '@ane/exp-data/lib/resources/MdsDataplaneResource';
import NavigationService from '@ane/core/lib/services/NavigationService';
import { constructFlightDetailsURL } from '../../../../utils/FlightRoute.utils';
const updateFlightArgs = {
    filterOnType: updateFlightActionTypes.UPDATE,
    loadResource: (payload, state) => {
        const { flightId, workspaceId, managementGroup, configuration } = payload;
        return FlightResource.updateFlight(flightId, workspaceId, managementGroup, getTenantFromManagementGroup(managementGroup), configuration || {});
    },
    loadingAction: updatingFlight,
    loadedAction: (successData, payload, error) => {
        var _a, _b;
        if (!error) {
            const result = { status: AsyncRequestStatus.Completed, error: '' };
            const workspaceId = ((_a = payload.configuration) === null || _a === void 0 ? void 0 : _a.WorkspaceId) || payload.workspaceId;
            const updatedManagementGroup = ((_b = payload.configuration) === null || _b === void 0 ? void 0 : _b.ManagementGroup) || payload.managementGroup;
            // Attempt to redirect using the config's management group in case the user changed the MG of the flight.
            return of(updatedFlight(payload, result), loadOverview(payload.flightId, workspaceId, updatedManagementGroup), loadFlightControl(payload.flightId, workspaceId, updatedManagementGroup), navigateToDetails(payload.flightId, workspaceId, updatedManagementGroup));
        }
        else {
            return of(updatedFlight(payload, { status: AsyncRequestStatus.Failed, error: error }));
        }
    },
};
export const updateFlightEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(updateFlightArgs);
export const navigateToDetailsEpic = (action$) => {
    return action$.pipe(ofType(updateFlightActionTypes.NAVIGATE_TO_DETAILS), mergeMap((action) => {
        const { flightId, workspaceId, managementGroup } = action.payload;
        NavigationService.navigateTo(constructFlightDetailsURL(flightId, workspaceId, managementGroup));
        return of(navigatedToDetails());
    }));
};
const loadManagementGroupPathsArgs = {
    filterOnType: loadPathsActionTypes.LOAD,
    loadResource: (payload, state) => {
        const { workspaceId } = payload;
        return MdsDataplaneResource.getPaths(workspaceId, false);
    },
    loadingAction: loadingManagementGroupPaths,
    loadedAction: (successData, payload, error) => {
        // Only load paths matching the tenant name
        // Example. ['/azure', '/bing', '/bing/2'] and tenant = 'bing' will return only the bing paths
        const tenantPaths = (successData || []).filter((p) => p.toLocaleLowerCase().indexOf(payload.tenant.toLocaleLowerCase()) === 1);
        return of(loadedManagementGroupPaths(payload.flightId, getCompletedAsyncWrapperObj(tenantPaths, error || '')));
    },
};
export const loadManagementGroupPathsEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadManagementGroupPathsArgs);
export default combineEpics(updateFlightEpic, navigateToDetailsEpic, loadManagementGroupPathsEpic);

//# sourceMappingURL=FlightEdit.epics.js.map
